import type { DepositAccount } from '@fruitful/types';
import {
    BodyMediumEmphasized,
    FootnoteRegular,
    XStack,
    YStack,
} from 'smoothie';

import { getNormalizedDepositAccountNickname } from '../../../common/utils/bankingUtils';

interface TransferAccountNameProps {
    depositAccount: DepositAccount;
}

const TransferAccountName = ({ depositAccount }: TransferAccountNameProps) => {
    const { bankName, accountNumberMasked } = depositAccount;
    return (
        <YStack alignItems="flex-end">
            <BodyMediumEmphasized>
                {getNormalizedDepositAccountNickname(depositAccount)}
            </BodyMediumEmphasized>
            <XStack>
                <FootnoteRegular color="$gray1000">
                    {bankName} *{accountNumberMasked}
                </FootnoteRegular>
            </XStack>
        </YStack>
    );
};

export default TransferAccountName;
